<script>
export default {
  name: 'CrownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 16,
    },
    color: {
      type: String,
      default: '#F3BA00',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.8337 14.6667H5.16699C4.89366 14.6667 4.66699 14.4401 4.66699 14.1667C4.66699 13.8934 4.89366 13.6667 5.16699 13.6667H11.8337C12.107 13.6667 12.3337 13.8934 12.3337 14.1667C12.3337 14.4401 12.107 14.6667 11.8337 14.6667Z"
      fill="#F3BA00"
    />
    <path
      d="M14.0668 3.68011L11.4001 5.58677C11.0468 5.84011 10.5401 5.68677 10.3868 5.28011L9.12681 1.92011C8.91348 1.34011 8.09348 1.34011 7.88015 1.92011L6.61348 5.27344C6.46015 5.68677 5.96015 5.84011 5.60681 5.58011L2.94015 3.67344C2.40681 3.30011 1.70015 3.82677 1.92015 4.44677L4.69348 12.2134C4.78681 12.4801 5.04015 12.6534 5.32015 12.6534H11.6735C11.9535 12.6534 12.2068 12.4734 12.3001 12.2134L15.0735 4.44677C15.3001 3.82677 14.5935 3.30011 14.0668 3.68011ZM10.1668 9.83344H6.83348C6.56015 9.83344 6.33348 9.60677 6.33348 9.33344C6.33348 9.06011 6.56015 8.83344 6.83348 8.83344H10.1668C10.4401 8.83344 10.6668 9.06011 10.6668 9.33344C10.6668 9.60677 10.4401 9.83344 10.1668 9.83344Z"
      fill="#F3BA00"
    />
  </svg>
</template>
